import React from 'react'
import API from "../../config/config";

export default function ProductMediaWidgetInfo({getClass, btnOne, btnTwo} :any) {
    return (
        <>
        <video
          autoPlay
          loop
          playsInline
          muted
          id="video1"
          src={API.baseUrl + btnOne.media.url}
          className={"media-video-container " + getClass(1)}
        >
          {/* <track
            src="captions_en.vtt"
            kind="captions"
            srcLang="en"
            label="english_captions"
          ></track> */}
        </video>
        <video
          playsInline
          autoPlay
          loop
          muted
          id="video2"
          src={API.baseUrl + btnTwo.media.url}
          className={"media-video-container " + getClass(2)}
        >
          {/* <track
            src="captions_en.vtt"
            kind="captions"
            srcLang="en"
            label="english_captions"
          ></track> */}
        </video>
      </>
    )
}
